import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BasePage } from 'src/pages/base.page';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { LoadingController, ToastController, MenuController, NavController, IonContent } from '@ionic/angular';

import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { ResultadoViewModel } from './ResultadoViewModel';

@Component({
  selector: 'resultado-page',
  templateUrl: 'resultado.page.html',
  styleUrls: ['resultado.page.scss']
})
export class Resultado extends BasePage {
    @ViewChild(IonContent) content: IonContent;
    
    constructor(
      public router: Router, 
      private loadingController: LoadingController,
      public toastCtrl: ToastController,
      public menuCtrl: MenuController,
      public navCtrl: NavController) {
      super(router)
    }

    resultado = {
        icone: "../../../assets/img/transparente.png"
    }
    
    alertComponent: AlertComponent
    loadingComponent: LoadingComponent
    formularioTraderViewModel: ResultadoViewModel

    async ngOnInit() {
        this.iniciaVariaveis()
        this.menuCtrl.enable(false)
    }

    async ionViewWillEnter() {
        this.scrollToTop()
        await this.buscaResultadoFormulario()
    }
  
    iniciaVariaveis() {
        this.loadingComponent = new LoadingComponent(this.loadingController)
        this.formularioTraderViewModel = new ResultadoViewModel()
        this.formularioTraderViewModel.setContext(this)
    }

    scrollToTop() {
        this.content.scrollToTop(500);
    }

    async buscaResultadoFormulario() {
        let loading = await this.showLoading()
        try {
            let retorno = await this.formularioTraderViewModel.apiResultadoFormulairoTrader()
            this.resultado = retorno
        } catch (e) {
            this.showAlert("Olá", "Ainda não processamos seu resultado, aguarde alguns instantes e acesse a funcionalidade novamente")
        }
        if (loading != null) {
            loading.dismiss()
        }
    }

    showAlert(title: string, message: string) {
        AlertComponent.showAlert(title, message)
    }

    async showLoading() {
        return await this.loadingComponent.showLoading()
    }

    fecharTela() {
        this.openPage('home')
        this.navCtrl.pop();
    }

    abrirPesquisa() {
        this.openPage('formulario-trader', {
            telaResultado: true
        })
    }
}